<ng-container>
  <h5>Phone Number to Call</h5>
  <div class="extension-detail-item">{{ extensionExternalForward?.forwardToNumber | formatPhoneNumbers }}</div>
</ng-container>

@if (extensionExternalForward?.isDtmf) {
  <h5>Seconds to pause before playing DTMF</h5>
  <div class="extension-detail-item">{{ extensionExternalForward?.pauseSeconds }}</div>
}
@if (extensionExternalForward?.isDtmf) {
  <h5>DTMF to play</h5>
  <div class="extension-detail-item">{{ extensionExternalForward?.dtmf }}</div>
}
